import axios from "axios";
import { AUTH_API_URL } from "../config/api";

export const authService = {
  async login(email: string, password: string) {
    try {
      const response = await axios.post(`${AUTH_API_URL}/user/login`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

   // Get current user by token
  async getCurrentUser(token: string): Promise<any> {
    try {
      const response = await axios.get(`${AUTH_API_URL}/user/get_user_by_token`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.user;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'utilisateur connecté :", error);
      throw error;
    }
  },
};
